// DS: i3.41 Studio Scheduled
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioScheduled: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="m10.732 2.003.312 2.39a7.631 7.631 0 0 0 .998 15.197 7.63 7.63 0 0 0 7.568-6.634l2.39.312c-.642 4.926-4.855 8.73-9.958 8.73C6.496 21.998 2 17.503 2 11.958c0-5.102 3.807-9.316 8.736-9.956z"></path>
        <path d="m22 10.649-2.39.311a7.6 7.6 0 0 0-.515-1.923l2.227-.923c.33.798.562 1.648.677 2.535M20.009 5.845l-1.911 1.468a7.7 7.7 0 0 0-1.41-1.41l1.468-1.91a10 10 0 0 1 1.853 1.852M15.886 2.68l-.923 2.226a7.6 7.6 0 0 0-1.923-.514l.312-2.39h-.006c.889.115 1.74.347 2.54.678M12.946 8.618c0-.663-.54-1.2-1.205-1.2s-1.205.537-1.205 1.2v4.5c0 .828.674 1.5 1.506 1.5h3.314c.666 0 1.205-.537 1.205-1.2s-.54-1.2-1.205-1.2h-2.41z"></path>
      </svg>
    </IconWrap>
  );
};
StudioScheduled.displayName = 'StudioScheduled';

export default StudioScheduled;
